import axios from 'axios'
import qs from 'qs';


const API_PREFIX = "/api/fund"

export const apiFundCategories = () => {
    return axios.get(`${API_PREFIX}/public/categories`)
}

export const apiFundAmc = () => {
    return axios.get(`${API_PREFIX}/public/amc`)
}

export const apiFundList = () => {
    return axios.get(`${API_PREFIX}/public/list`)
}

export const apiFundDetail = fund_id => {
    return axios.get(`${API_PREFIX}/public/${fund_id}/overview`)
}

export const apiFundDetailByName = fund_name => {
    return axios.get(`${API_PREFIX}/public/${fund_name}/overview?queryby=name`)
}

export const apiFundTopHoldings = fund_id => {
    return axios.get(`${API_PREFIX}/public/topholdings/${fund_id}`)
}

export const apiFund3D = fund_id => {
    return axios.get(`${API_PREFIX}/public/3d/${fund_id}`)
}

export const apiFundPerformance = fund_id => {
    return axios.get(`${API_PREFIX}/public/${fund_id}/performance`)
}

export const apiFundBreakdown = fund_id => {
    return axios.get(`${API_PREFIX}/public/${fund_id}/breakdown`)
}

export const apiFundNav = (fund_id, period) => {
    return axios.get(`${API_PREFIX}/nav/q?fund=${fund_id}&range=${period}`)
}

export const apiFundNavLatest = fund_id => {
    return axios.get(`${API_PREFIX}/nav/latest?fund=${fund_id}`)
}

export const apiFundNavVerify = fund_id => {
    return axios.get(`${API_PREFIX}/nav/verify?fund=${fund_id}`)
}

export const apiFundFee = fund_id => {
    return axios.get(`${API_PREFIX}/public/${fund_id}/fee`)
}

export const apiFundDividend = fund_id => {
    return axios.get(`${API_PREFIX}/public/dividend/${fund_id}`)
}

export const apiFundTrendings = () => {
    return axios.get(`${API_PREFIX}/public/topfundwatch`)
}
export const apiFundFilter = payload => {
    return axios.get(`${API_PREFIX}/public/filter/overview?${payload}`)
}

export const apiFundCard  = payload => {
    return axios.post(`${API_PREFIX}/card`, payload)
}

export const apiFundInvestNow = payload => {
    return axios.post(`${API_PREFIX}/invest-now`, payload)
}